import { getDomainName } from '~/lang/utils/pulangfetch'
import { keysToCamel } from '~/utility/toCamel'
import { isAbortError } from '~/utility/isAbortError'
import { langFallback$Fetch } from '../../lang/utils/langfetch'

export async function getCsrfToken() {
  return keysToCamel(
    await langFallback$Fetch(
      'en-gb',
      `/accounts/ping/?domain=${getDomainName()}`,
    ),
  )
}

export async function csrfTokenService() {
  try {
    return await getCsrfToken()
  } catch (error) {
    // Filter out AbortErrors from navigation-based request cancellation
    // Don't re-throw them so consuming code doesn't log them
    if (isAbortError(error)) {
      // Return empty token object to prevent consuming code from failing
      return { csrfToken: '' }
    }

    // Re-throw all other errors as normal
    throw error
  }
}
